import { render } from "./index.vue?vue&type=template&id=70be0218"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/other/errorLog/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70be0218"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70be0218', __exports__)) {
    console.log('reload')
    api.reload('70be0218', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=70be0218", () => {
    console.log('re-render')
    api.rerender('70be0218', render)
  })

}


export default __exports__